import React, { useContext } from 'react'

import { ReactComponent as FailureImage } from '@assets/images/500_artwork.svg'
import { Button } from '@components/Button'

import Routes from '@utils/routes'

import { AstuteContext } from '../../context'

const FALLBACK_ERROR_MESSAGE = "Something went wrong fetching your report"

export const Failed = () => {
  const { state: { lastServiceRequest } } = useContext(AstuteContext)
  const errorMessage = lastServiceRequest?.humanisedErrorMessage || FALLBACK_ERROR_MESSAGE

  return (
    <div className='astute-request-wrapper'>
      <h1>Something went wrong</h1>

      <p className='astute-request-wrapper--subheading'>
        The paper planes seemed to have crashed...
      </p>

      <p>We collected the following error message from Astute: </p>
      <p style={{ fontFamily: "monospace" }}>{errorMessage}</p>

      <div className='astute-request-wrapper--graphic-svg' style={{marginBlockEnd: '2rem'}}>
        <FailureImage style={{width: '350px', height: 'fit-content'}}/>
      </div>

      <p>You may retry the request below.</p>

      <FailedStateActionRow />
    </div>
  )
}

const FailedStateActionRow = () => {
  const {
    state: {
      client,
      paths: { retryPath },
    },
  } = useContext(AstuteContext)

  return (
    <div className='astute-back-to-dashboard'>
      <Button name='Cancel' href={Routes.clientDashboardPath({ clientId: client.id })} secondary>
        Cancel
      </Button>
      <div className='refresh-button-wrapper'>
        <Button href={retryPath} name='Retry request'>
          Retry request
        </Button>
      </div>
    </div>
  )
}
